import * as Types from '../types';

interface ReqAdminSyncForceUpdateAction {
  type: string;
  payload: {
    userId: string;
    costCenterId: string;
  };
}

export function reqAdminSyncForceUpdate(
  userId: string,
  costCenterId: string,
): ReqAdminSyncForceUpdateAction {
  return {
    type: Types.REQ_ADMIN_SYNC_FORCE_UPDATE,
    payload: {
      userId,
      costCenterId,
    },
  };
}
